module.exports = __webpack_public_path__ + "static/media/capl.e31ea4a3.png";